<template>
<div class="chapter">
<div class="inner_page">
<div class="generated-style" id="fm-00-openingpage-image">
<p class="image" xml:lang="en-us"><span class="generated-style-2"><img alt="IcePops_OpeningPage_kindle.gif" class="generated-style-2" src="Images/IcePops_OpeningPage_ki_fmt.jpeg"/></span></p>
<p class="image" xml:lang="en-us"><span class="generated-style-2"><img alt="FM_01_OpeningPage_image.jpg" class="generated-style-2" src="Images/FM_01_OpeningPage_imag_fmt.jpeg"/></span></p>
<p class="image" xml:lang="en-us"><span class="generated-style-2"><img alt="IcePops_TitlePage_kindle.gif" class="generated-style-2" src="Images/IcePops_TitlePage_kind_fmt.jpeg"/></span></p>
<p class="image" xml:lang="en-us"><span class="generated-style-2"><img alt="FM_03_OpeningMainTOC_ePub_image.jpg" class="generated-style-2" src="Images/FM_03_OpeningMainTOC_e_fmt.jpeg"/></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FM_00_OpeningPage_image.vue?30625828